import React from 'react';
import { Toaster } from 'react-hot-toast';

const AppNotification = () => {
  return (
    <Toaster
      position="bottom-center"
      reverseOrder={false}
      toastOptions={{
        className: '',
        duration: 6e5,
        style: {
          background: '#333333',
          color: '#fee715',
          zIndex: 1,
          maxWidth: 380,
          textAlign: 'center',
        },
      }}
    />
  );
};

export default AppNotification;
